import React from "react";
import { Stack } from "@mui/material";
import { GQLContentForm } from "@quales/data-access/graphql";
import Editor from "@monaco-editor/react";
import { CustomTypographyComponent } from "../ui/text";
import { useTheme } from "@quales/utils/theme";
import { validJson } from "../utils";
import debounce from "lodash.debounce";
interface SchemaFormProps {
  data?: GQLContentForm;
  onValueChange: (data: any) => void;
}

const monacoEditorOptions = {
  minimap: {
    enabled: false,
  },
  automaticLayout: true,
};

export const SchemaForm = React.forwardRef((props: SchemaFormProps, ref) => {
  const { onValueChange, data } = props;
  const [formValue, setFormValue] = React.useState<string>();
  const [formErrors, setFormErrors] = React.useState([]);
  const theme = useTheme();

  const debouncedSave = React.useCallback(
    debounce((nextValue: string) => onValueChange(nextValue), 1000),
    [onValueChange] // will be created only once initially
  );

  React.useEffect(() => {
    if (data) {
      //@ts-ignore
      setFormValue(JSON.stringify(data.formSchema, null, 2));
    }
  }, [data]);

  const onChange = (value: any) => {
    if (value && validJson(value)) {
      setFormValue(value);
      debouncedSave({
        value,
      });
    }
  };
  const handleEditorValidation = (markers) => {
    setFormErrors(markers);
  };

  return (
    <Stack height={600} overflow={"auto"} width="100%" id="SchemaForm">
      <Stack padding={2}>
        {formErrors &&
          formErrors.length > 0 &&
          formErrors.map((formError, index: number) => (
            <CustomTypographyComponent
              key={index}
              color={theme.appColors.error}
            >
              {formError.message} at line {formError.startLineNumber} at column{" "}
              {formError.startColumn}
            </CustomTypographyComponent>
          ))}
      </Stack>
      <Editor
        height="90vh"
        value={formValue}
        language="json"
        onChange={onChange}
        onValidate={handleEditorValidation}
        options={monacoEditorOptions}
      />
    </Stack>
  );
});

SchemaForm.displayName = "SchemaForm";
export default SchemaForm;
